<template>
    <header>
        <div class="nav-container">
            <div class="menu-container desktop-menu">
                <div class="menu-logo">
                    <img src="../assets/home/logo.png" style=" width: 120px;" />
                </div>

                <div class="menu-content">
                    <router-link to="/" class="menu-item">ACCUEIL</router-link>
                    <router-link to="/Shop" class="menu-item">BOUTIQUE</router-link>
                    <router-link to="/Skincare" class="menu-item">SOINS VISAGE</router-link>
                    <router-link to="/About" class="menu-item">NOTRE HISTOIRE</router-link>
                    <a href="javascript:;" class="menu-item" @click="toContactUs">CONTACT US</a>
                </div>

                <div style="flex: 1; text-align: center;">
                    <svg viewBox="0 0 20 20" style="width: 22px;cursor:pointer;"><path d="M17.78,16.72l-3.25-3.25a.53.53,0,0,0-.1-.06,7,7,0,1,0-1,1,.53.53,0,0,0,.06.1l3.25,3.25a.75.75,0,0,0,1.06,0A.75.75,0,0,0,17.78,16.72ZM9,14.65A5.65,5.65,0,1,1,14.65,9,5.66,5.66,0,0,1,9,14.65Z"></path></svg>
                </div>
            </div>

            <div class="menu-container mobile-menu-container">
                <div class="mobile-menu-button-container">
                    <button class="mobile-menu-button" @click="isMobileMenuOpen = !isMobileMenuOpen">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 12H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            <path d="M3 6H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            <path d="M3 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </button>
                </div>
                <div class="menu-logo">
                    <img src="../assets/home/logo.png" style=" width: 120px;" />
                </div>
                <div class="mobile-menu-button-container">
                </div>
            </div>
        </div>

        <div class="mobile-menu" :class="{ 'is-open': isMobileMenuOpen }">
            <el-menu :default-active="activeIndex"
                     background-color="#ffffff" router="true"
                     text-color="#333333"
                     active-text-color="#333333"
                     @select="isMobileMenuOpen = false">
                <el-menu-item index="/">
                    <el-icon><House /></el-icon>
                    <span>ACCUEIL</span>
                </el-menu-item>
                <el-menu-item index="/Shop">
                    <el-icon><Folder /></el-icon>
                    <span>BOUTIQUE</span>
                </el-menu-item>
                <el-menu-item index="/Skincare">
                    <el-icon><Goods /></el-icon>
                    <span>SOINS VISAGE</span>
                </el-menu-item>
                <el-menu-item index="/About">
                    <el-icon><InfoFilled /></el-icon>
                    <span>NOTRE HISTOIRE</span>
                </el-menu-item>
                <el-menu-item index="/About">
                    <el-icon><InfoFilled /></el-icon>
                    <span>CONTACT US</span>
                </el-menu-item>
            </el-menu>
        </div>
    </header>
</template>

<script >
    import {
        House,
        Folder,
        Goods,
        InfoFilled
    } from '@element-plus/icons-vue'

    export default {
        name: 'NavigationMenu',
        components: {
            House,
            Folder,
            Goods,
            InfoFilled
        },
        props: {
            products: Array
        },
        data() {
            return {
                isMobileMenuOpen: false,
                activeIndex:1,
            }
        },
        methods: {
            toContactUs() {
                window.open("skype:13000000000?chat");
            }
        }
    }
</script>


<style scoped>
    .desktop-menu {
        display: flex;
        width: 100%;
        align-items: center;
    }

    .desktop-menu .menu-logo {
        width: 25%;
    }

        .desktop-menu .menu-logo img {
            margin: 0vw 0% 0vw 14.6138%;
        }

        .desktop-menu .menu-content {
            width: 58.33%;
            display: flex;
            padding: 0 16px;
        }

        .desktop-menu .menu-item {
            display: block;
            text-decoration: none;
            color: rgba(35, 35, 35, 1);
            font-size: calc(var(--fontRatio, 1) * 20px);
            min-width: 150px;
            height: 85px;
            line-height: 85px;
            border-width: 0px;
            border-top-style: solid;
            border-bottom-style: solid;
            border-left-style: solid;
            border-right-style: solid;
            border-color: #212121;
            text-align: center;
            margin-right: 30px;
            white-space: nowrap;
        }

    .mobile-menu-button-container{
    width:100px;
    }

    .mobile-menu-container .menu-logo{
        flex:1;
        text-align:center;
    }

    .mobile-menu-container {
        display:none;
        width: 100%;
        align-items: center;
    }

    header {
        background: rgba(255, 255, 255, 0.8957345971563981);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        position: fixed;
        top: 0;
        z-index: 1000;
        width: 100%;
    }

    .nav-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 84px;
    }

    .logo {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 22px;
        margin-left: 30px;
        color: black;
    }

        .logo .el-icon {
            margin-right: 10px;
            font-size: 28px;
        }

    .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
        background-color: initial !important;
    }

    /* 透明菜单样式 */
    .transparent-menu {
        background: rgba(255, 255, 255, 0.1) !important;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 8px;
    }

        .transparent-menu .el-menu-item {
            color: rgba(255, 255, 255, 0.9) !important;
            height: 50px;
            line-height: 50px;
            margin: 0 5px;
            border-radius: 6px;
        }

            .transparent-menu .el-menu-item:hover {
                background: rgba(255, 255, 255, 0.15) !important;
            }

            .transparent-menu .el-menu-item.is-active {
                background: rgba(255, 255, 255, 0.1) !important;
                color: #fff !important;
                font-weight: bold;
            }

        .transparent-menu .el-sub-menu__title {
            color: rgba(255, 255, 255, 0.9) !important;
        }

            .transparent-menu .el-sub-menu__title:hover {
                background: rgba(255, 255, 255, 0.15) !important;
            }

    .desktop-menu {
        flex: 1;
        display: flex;
        justify-content: center;
        border-bottom: none !important;
    }

        .desktop-menu .el-menu-item{
            margin:0 20px;
            font-size:20px;
        }

    .el-menu--horizontal > .el-menu-item.is-active {
        border: none;
        background-color: initial !important;
        color: black !important;
        font-weight: bold;
    }

        .desktop-menu :deep(.el-menu--horizontal > .el-menu-item) {
            height: 64px;
            line-height: 64px;
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.9);
            margin: 0 40px;
            font-size: 20px;
        }

        .desktop-menu :deep(.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover) {
            background-color: rgba(255, 255, 255, 0.1);
            color: #fff;
        }

        .desktop-menu :deep(.el-menu--horizontal > .el-menu-item.is-active) {
            color: #fff;
            border-bottom: 3px solid #fff;
        }

    .mobile-menu-button {
        display: none;
        color: black;
        font-size: 24px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 5px;
    }

    .mobile-menu {
        display: none;
        background-color: white;
        padding: 10px 0;
        height: 100vh;
    }

        .mobile-menu :deep(.el-menu) {
            border-right: none;
            background-color: transparent;
        }

        .mobile-menu :deep(.el-menu-item) {
            height: 100px;
            line-height: 100px;
            color: #666;
            font-size: 20px;
            border-bottom: 1px solid #f2f2f2;
        }

        .mobile-menu :deep(.el-menu-item:hover) {
            background-color: rgba(255, 255, 255, 0.1);
        }

        .mobile-menu :deep(.el-menu-item.is-active) {
            color: #000000;
            background-color: rgb(238 238 238 / 20%);
        }

    /* 响应式设计 */
    @media screen and (max-width: 768px) {
        .desktop-menu {
            display: none;
        }

        .mobile-menu-button {
            display: block;
        }

        .mobile-menu.is-open {
            display: block;
        }

        .nav-container {
            padding: 0 15px;
            background-color:white;
        }

        .mobile-menu-container{
            display:flex;
        }

    }

    @media screen and (max-width: 480px) {
        .logo span {
            font-size: 18px;
        }

        .logo .el-icon {
            font-size: 24px;
        }
    }
</style>

